import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'
import { withRouter } from 'react-router'
import { getAdminReasons } from '../../../actions/adminActions'
import { Link } from 'react-router-dom'
import { FaPlusSquare, FaEdit } from 'react-icons/fa'
import PropTypes from 'prop-types'

const FilterableTable = require('react-filterable-table')

class AdminReasons extends Component {
  componentWillMount () {
    this.props.getAdminReasons()
  }

  render () {
    const renderEdit = (props) => {
      if (props.record.label === 'other') return null
      return (
        <Link className='btn-input btn btn-sm' to={`/admin/reason/${props.value}`}><FaEdit /> Edit</Link>
      )
    }
    // Fields to show in the table, and what object properties in the data they bind to
    const fields = [
      { name: 'reason', displayName: 'Reason', inputFilterable: true, sortable: true },
      { name: 'id', displayName: '', inputFilterable: false, exactFilterable: false, sortable: false, render: renderEdit, tdClassName: 'text-right' }

    ]

    return (

      <div>
        <Row>
          <Col>
            <h1>Reasons</h1>
          </Col>
        </Row>
        <Row className='content pt-5 pb-5'>
          <Col>
            {this.props.admin.loading
              ? <div className='table-loading-spinner' />
              : null }
            <FilterableTable
              namespace='Admin Reasons'
              initialSort='first_name'
              data={(this.props.admin.reasons !== null) ? this.props.admin.reasons : []}
              fields={fields}
              noRecordsMessage='There are no reasons to display'
              noFilteredRecordsMessage='No match'
              topPagerVisible={false}
              tableClassName='table table-bordered'
            />
            <Link to='/admin/reason/create' className='mt-2 btn btn-primary'><FaPlusSquare /> Create reason</Link>

          </Col>

        </Row>

      </div>
    )
  }
};

AdminReasons.propTypes = {
  getAdminReasons: PropTypes.func,
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAdminReasons
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminReasons))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminReasons/AdminReasons.jsx